import { cloneElement } from 'react';
import { useIsMobile } from '../../../../../utils/getIsMobile';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { BusinessStatisticInfo } from '../../../BusinessStatisticInfo/BusinessStatisticInfo';
import { BusinessStatisticSectionFlex } from './styles';
import { BusinessStatisticSectionProps } from './types';

export const BusinessStatisticSection = (props: BusinessStatisticSectionProps) => {
    const { title, statsSlot, helpMessage, ...other } = props;
    const isMobile = useIsMobile();

    return (
        <BusinessStatisticSectionFlex
            width={{ xs: '100%', sm: '50%' }}
            p={2}
            isMobile={isMobile}
            {...other}
        >
            <Flex direction="row" spacing={0.5} alignItems="center">
                <Typography variant="title3" weight="bold">
                    {title}
                </Typography>
                <BusinessStatisticInfo ml={-0.5} title={title} hasCloseButton>
                    {helpMessage}
                </BusinessStatisticInfo>
            </Flex>
            <Flex width="100%" direction="row" flexWrap="wrap">
                {cloneElement(statsSlot)}
            </Flex>
        </BusinessStatisticSectionFlex>
    );
};
